import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fields } from '../../common/lib/redux-fields'
import { validateCreateOptions } from '../../common/lessons/validations'
import { createLesson } from '../../common/lessons/actions'
import formValidation from '../../common/lib/formValidation'
import { updateMe } from '../../common/users/actions'
import { exerciseTypes } from '../../common/config'
import { LessonFormHeader } from '../forms'
import { withNameInput, Popup, Button, TextInput, Checkbox, RadioInput } from '../components'


class OptionsForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: '',
      instructions: '',
      isPublic: true,
      onlyOneCorrect: true,
      questions: [],
      foreignLang: props.viewer && props.viewer.learningLanguage,
    }
  }

  componentDidMount() {
    const { lesson } = this.props
    if (lesson) {
      this.setState({
        id: lesson.id,
        isPublic: lesson.isPublic,
        instructions: lesson.instructions,
        foreignLang: lesson.foreignLang,
        onlyOneCorrect: lesson.options.onlyOneCorrect,
        questions: lesson.options.questions,
      })
    } else {
      const questions = []
      /* TODO set some amount of questions */
      for (let i = 0; i < 1; i += 1) {
        questions.push({
          text: '',
          answers: ['', ''],
          correctAnswers: [0],
        })
      }
      this.setState({ questions })
    }
  }

  componentWillUnmount() {
    const { fields } = this.props
    fields.$reset()
  }

  async submitForm(e) {
    e.preventDefault()
    const { fields, submit, history, isTestForm, hideForm } = this.props
    const { foreignLang, id, isPublic, questions, onlyOneCorrect } = this.state

    const values = {
      ...fields.$values(),
      id,
      isPublic,
      foreignLang,
      questions,
      onlyOneCorrect,
      type: exerciseTypes.OPTIONS,
    }
    if (await submit(values) !== false) {
      fields.$reset()
      if (!isTestForm) {
        history.push('/app/lessons')
      } else {
        hideForm()
      }
    }
  }

  addQuestion() {
    const { questions } = this.state
    this.setState({
      questions: [...questions, {
        text: '',
        answers: ['', ''],
        correctAnswers: [0],
      }],
    })
  }

  updateQuestionText(e, qid) {
    const { questions } = this.state
    const newQuestions = questions.map((q, qidx) => {
      if (qid === qidx) {
        return {
          ...q,
          text: e.target.value,
        }
      }
      return q
    })
    this.setState({
      questions: newQuestions,
    })
  }

  removeQuestion(qid) {
    const { questions } = this.state
    this.setState({
      questions: questions.filter((q, id) => id !== qid),
    })
  }

  addAnswer(qid) {
    const { questions } = this.state
    const newQuestions = questions.map((q, idx) => {
      if (qid === idx) {
        return {
          ...q,
          answers: [...q.answers, ''],
        }
      }
      return q
    })
    this.setState({
      questions: newQuestions,
    })
  }

  removeAnswer(qid, aid) {
    const { questions } = this.state
    const newQuestions = questions.map((q, id) => {
      if (qid === id) {
        const newAnswers = q.answers
        newAnswers.splice(aid, 1)
        const newCorrectAnswers = q.correctAnswers
          .filter(a => a !== aid)
          .map(a => {
            if (a > aid) {
              return a - 1
            }
            return a
          }).filter(a => a < newAnswers.length)
        return {
          ...q,
          answers: newAnswers,
          correctAnswers: newCorrectAnswers,
        }
      }
      return q
    })
    this.setState({
      questions: newQuestions,
    })
  }

  toggleAnswer(qid, aid) {
    const { questions, onlyOneCorrect } = this.state
    const newQuestions = questions.map((q, id) => {
      if (qid === id) {
        if (q.correctAnswers.includes(aid)) {
          return {
            ...q,
            correctAnswers: q.correctAnswers.filter(a => a !== aid),
          }
        }
        return {
          ...q,
          correctAnswers: onlyOneCorrect ? [aid] : [...q.correctAnswers, aid],
        }
      }
      return q
    })
    this.setState({
      questions: newQuestions,
    })
  }

  changeAnswerText(e, qid, aid) {
    const newText = e.target.value
    const { questions } = this.state
    const newQuestions = questions.map((q, id) => {
      if (qid === id) {
        const newAnswers = q.answers.map((a, idx) => {
          if (idx === aid) {
            return newText
          }
          return a
        })
        return {
          ...q,
          answers: newAnswers,
        }
      }
      return q
    })
    this.setState({
      questions: newQuestions,
    })
  }

  handleChangeLang(e) {
    this.setState({
      foreignLang: e.target.value,
    })
  }

  handleSingleChoiceChange() {
    const { onlyOneCorrect, questions } = this.state
    let newQuestions = questions
    if (!onlyOneCorrect) {
      newQuestions = newQuestions.map(q => {
        if (q.correctAnswers.length > 1) {
          q.correctAnswers = [q.correctAnswers[0]]
        } else if (q.correctAnswers.length === 0) {
          q.correctAnswers = [0]
        }
        return q
      })
    }
    this.setState({
      onlyOneCorrect: !this.state.onlyOneCorrect,
      questions: newQuestions,
    })
  }

  render() {
    const { viewer, fields, errorMessage, lesson, isDetailPage, updateMe, intl } = this.props
    const { questions, onlyOneCorrect } = this.state

    return (
      <div className="options-form float-left width-full">
        {
          !isDetailPage && viewer && !viewer.seenGuides.optionsDescription &&
          <Popup
            title={intl.formatMessage(messages.popupTitle)}
            text={intl.formatMessage(messages.popupContent)}
            onClick={() => updateMe({ seenGuides: { optionsDescription: true } })}
          />
        }
        <form className="flex-column" onSubmit={(e) => this.submitForm(e)}>
          <LessonFormHeader
            isDetailPage={isDetailPage}
            errors={errorMessage}
            fields={fields}
            lesson={lesson}
          />
          <div className="float-left width-full checkbox-wrapper">
            <Checkbox
              id="onlyOneCorrect"
              disabled={isDetailPage}
              checked={onlyOneCorrect}
              onChange={() => this.handleSingleChoiceChange()}
              label={intl.formatMessage(messages.onlyOneCorrect)}
            />
          </div>
          <div className="width-full">
            {
              questions.map((q, qidx) => (
                <div key={`${qidx}`} className="column-direction question-item">
                  <TextInput
                    id={`${qidx}`}
                    className="question-text-box width-full"
                    disabled={isDetailPage}
                    value={q.text}
                    onChange={(e) => this.updateQuestionText(e, qidx)}
                    label={intl.formatMessage(messages.question)}
                    placeholder={intl.formatMessage(messages.enterQuestion)}
                  />
                  <div className="answers-box width-full">
                    {
                      q.answers.map((a, idx) => (
                        <div
                          key={`${qidx}--${idx}`}
                          className="answer-box-item width-25"
                        >
                          {
                            onlyOneCorrect ?
                              <RadioInput
                                id={`${qidx}--${idx}`}
                                type="onlyOneCorrect"
                                checked={q.correctAnswers.includes(idx)}
                                onChange={() => this.toggleAnswer(qidx, idx)}
                                disabled={isDetailPage}
                              />
                            :
                              <Checkbox
                                id={`${qidx}--${idx}`}
                                checked={q.correctAnswers.includes(idx)}
                                onChange={() => this.toggleAnswer(qidx, idx)}
                                disabled={isDetailPage}
                              />
                          }
                          <TextInput
                            id={`${qidx}--${idx}`}
                            disabled={isDetailPage}
                            value={a}
                            className="horizontal-spacing disable-vertical-spacing"
                            placeholder={intl.formatMessage(messages.enterAnswer)}
                            onChange={(e) => this.changeAnswerText(e, qidx, idx)}
                          />
                          {
                            !isDetailPage &&
                            <FontAwesomeIcon
                              icon="trash"
                              className="delete-icon"
                              onClick={() => this.removeAnswer(qidx, idx)}
                            />
                          }
                        </div>
                      ))
                    }
                    {
                      !isDetailPage &&
                      <div className="width-full flex-row-spacing question-buttons">
                        <Button
                          onClick={() => this.addAnswer(qidx)}
                          className="disable-spacing-left"
                        >
                          {intl.formatMessage(messages.addAnswer)}
                        </Button>
                        <Button
                          icon="trash"
                          negative
                          className="float-right disable-spacing-right"
                          onClick={() => this.removeQuestion(qidx)}
                        >
                          {intl.formatMessage(messages.removeQuestion)}
                        </Button>
                      </div>
                    }
                  </div>
                </div>
              ))
            }
            {
              !isDetailPage &&
              <div>
                <div className="item-box noborder">
                  <div className="block-center">
                    <Button
                      onClick={() => this.addQuestion()}
                    >
                      {intl.formatMessage(messages.addQuestion)}
                    </Button>
                  </div>
                </div>
                <div className="float-left block-center bottom-save-button">
                  <Button big positive type="submit">
                    {intl.formatMessage(messages.save)}
                  </Button>
                </div>
              </div>
            }
          </div>
        </form>
      </div>
    )
  }
}

OptionsForm.defaultProps = {
  lesson: null,
  viewer: null,
  isDetailPage: false,
}

OptionsForm.propTypes = {
  intl: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  viewer: PropTypes.object,
  lesson: PropTypes.object,
  submit: PropTypes.func.isRequired,
  updateMe: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  errorMessage: PropTypes.any.isRequired,
  isDetailPage: PropTypes.bool,
}

OptionsForm = withRouter(OptionsForm)

const enhance = compose(
  withNameInput,
  formValidation(props => ({
    validationFunc: validateCreateOptions,
    submitFunc: props.submitLesson,
  })),
  connect(state => ({
    viewer: state.users.viewer,
  }), { createLesson, updateMe }),
  fields({
    path: 'OptionsForm',
    fields: [
      'name',
      'instructions',
      'youtubeVideo',
      'prologueText',
      // 'subject',
      'tags',
    ],
    getInitialState: ({ lesson, viewer, ...props }) => ({
      name: (lesson && lesson.name) || props.name || '',
      instructions: ((lesson && lesson.instructions)
        ? lesson.instructions : ''),
      prologueText: (lesson && lesson.prologueText) || props.prologueText || '',
      youtubeVideo: (lesson && lesson.youtubeVideo) || props.youtubeVideo || '',
      tags: (lesson && lesson.tags) || props.tags || [],
      // subject: (lesson && lesson.subject) || props.subject || ((viewer.subjects.length && !lesson) ? viewer.subjects[0] : ''),
    }),
  }),
  injectIntl,
)

export default enhance(OptionsForm)

const messages = defineMessages({
  popupTitle: {
    id: 'options.form.popupTitle',
    defaultMessage: 'Inštrukcie',
  },
  popupContent: {
    id: 'options.form.popupContent',
    defaultMessage: 'Označte pri každej otázke správnu odpoveď.',
  },
  onlyOneCorrect: {
    id: 'options.form.onlyOneCorrect',
    defaultMessage: 'Len jedna správna odpoveď',
  },
  question: {
    id: 'options.form.question',
    defaultMessage: 'Otázka',
  },
  addQuestion: {
    id: 'options.form.addQuestion',
    defaultMessage: 'Pridajte otázku',
  },
  enterQuestion: {
    id: 'options.form.enterQuestion',
    defaultMessage: 'Zadajte otázku',
  },
  enterAnswer: {
    id: 'options.form.enterAnswer',
    defaultMessage: 'Zadajte opdoveď',
  },
  addAnswer: {
    id: 'options.form.addAnswer',
    defaultMessage: 'Pridajte opdoveď',
  },
  removeQuestion: {
    id: 'options.form.removeQuestion',
    defaultMessage: 'Odoberte otázku',
  },
  save: {
    id: 'options.form.save',
    defaultMessage: 'Uložiť',
  },
})



// WEBPACK FOOTER //
// ./src/browser/forms/OptionsForm.js